import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzAddOnModule } from 'ant-reset-private/core';
import { NzIconModule } from 'ant-reset-private/icon';

import { NzAlertComponent } from './nz-alert.component';

@NgModule({
  declarations: [NzAlertComponent],
  exports: [NzAlertComponent],
  imports: [CommonModule, NzIconModule, NzAddOnModule]
})
export class NzAlertModule {}
